import { GlobalProvider } from "./context/GlobalProvider";

import Pages from "./Pages/Pages";
import "./App.scss";

function App() {
  return (
    <GlobalProvider>
      <Pages />
    </GlobalProvider>
  );
}

export default App;
